var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9282 8.5843C14.1298 8.46747 14.3879 8.5361 14.5048 8.7377L16.115 11.515C16.2318 11.7166 16.1632 11.9747 15.9616 12.0916C15.76 12.2084 15.5019 12.1398 15.385 11.9382L13.7749 9.16087C13.658 8.95932 13.7266 8.70119 13.9282 8.5843Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.769 10.0807C10.9985 10.0403 11.2173 10.1935 11.2577 10.423L11.7569 13.2566C11.7973 13.4861 11.6441 13.7048 11.4147 13.7453C11.1852 13.7856 10.9664 13.6324 10.926 13.403L10.4267 10.5694C10.3864 10.3399 10.5396 10.1211 10.769 10.0807Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2238 10.0728C7.45325 10.1132 7.60658 10.3319 7.56625 10.5614L7.06703 13.402C7.0267 13.6314 6.808 13.7848 6.5785 13.7445C6.34906 13.7041 6.19572 13.4854 6.23605 13.2559L6.73527 10.4153C6.7756 10.1859 6.9943 10.0325 7.2238 10.0728Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06394 8.58386C4.26577 8.7003 4.335 8.95826 4.21858 9.16009L2.60843 11.9515C2.49201 12.1533 2.23402 12.2226 2.0322 12.1061C1.83037 11.9897 1.76113 11.7317 1.87755 11.5299L3.48771 8.73849C3.60413 8.53667 3.86212 8.46743 4.06394 8.58386Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98493 7.04682C2.16619 6.9004 2.43181 6.9287 2.57821 7.10994C3.71285 8.51472 5.76949 10.2649 9.00004 10.2649C12.2305 10.2649 14.2871 8.51472 15.4218 7.10994C15.5682 6.9287 15.8339 6.9004 16.0151 7.04682C16.1963 7.19324 16.2246 7.45885 16.0782 7.64009C14.8504 9.1603 12.5757 11.1086 9.00004 11.1086C5.42427 11.1086 3.14967 9.1603 1.92182 7.64009C1.77542 7.45885 1.80368 7.19324 1.98493 7.04682Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisOff);
export default __webpack_public_path__ + "static/media/visOff.3bbca99d90d48d94684fb0496d1fe634.svg";
export { ForwardRef as ReactComponent };